// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".snappy-badge[data-v-a8c4bf04]{font-size:12px;line-height:16px;border-radius:4px;padding:8px 12px}.snappy-badge--green[data-v-a8c4bf04]{background:#afe197;color:#006900}.snappy-badge--red[data-v-a8c4bf04]{background:rgba(237,59,56,.5);color:#b10300}.snappy-badge--grey[data-v-a8c4bf04]{background:#e9e9e9;color:#b6b6b6}", ""]);
// Exports
module.exports = exports;
